import { type SelectedValue } from '@databases/redux/cellSelections/slice';

/**
 * Returns selected cells in a format suitable for serialization (e.g. AIFC).
 * Returns a Set of cell keys in the format "entryId:fieldId".
 *
 * This includes:
 * - Individual selected cells
 * - All cells in selected entire fields (columns)
 * - All cells in selected entire entries (rows)
 */
export function serializeSelection({
  selectedEntireFields,
  selectedEntireEntries,
  selectedValues,
  database
}: {
  selectedEntireFields: readonly string[];
  selectedEntireEntries: readonly string[];
  selectedValues: readonly SelectedValue[];
  database: { entries: readonly string[]; fields: readonly string[] };
}): Set<string> {
  const cellKeys = new Set<string>();

  for (const { entryId, fieldId } of selectedValues) {
    cellKeys.add(`${entryId}:${fieldId}`);
  }

  for (const fieldId of selectedEntireFields) {
    for (const entryId of database.entries) {
      cellKeys.add(`${entryId}:${fieldId}`);
    }
  }

  for (const entryId of selectedEntireEntries) {
    for (const fieldId of database.fields) {
      cellKeys.add(`${entryId}:${fieldId}`);
    }
  }

  return cellKeys;
}
